module.exports = __webpack_public_path__ + "img/discount13.3b87875e.png";